<template>
  <el-config-provider :locale="locale">
    <router-view />
  </el-config-provider>
</template>

<script>
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'

export default {
  name: "app",
  components: {
    ElConfigProvider,
  },
  data() {
    return {
      locale: zhCn,
      language: "zh-CN"
    };
  },
  watch: {},
  computed: {},
  async mounted() {
    this.language = localStorage.getItem("language") || "zh-CN"
    if (this.language === "en") {
      this.locale = en
    } else {
      this.locale = zhCn
    }
  },
  methods: {},
};
</script>
<style scoped></style>
